/**
 * Live Stripe Payment Links — the no-login purchase path for logged-out/cold
 * traffic. Buyers land with no uid; the webhook reconciles them by email
 * (reconcilePaymentLinkUser): find-or-create the account, grant access, email
 * a magic link, seed the /try diagnostic. Verified live for fullAccess
 * 2026-08-09; the same checkout.session.completed rail covers the
 * subscription links (client_reference_id absent → email reconcile).
 *
 * ONE source of truth — TryAQuestion's results CTA and Pricing's logged-out
 * CTAs must never drift to different links for the same product.
 */
export const STRIPE_PAYMENT_LINKS = {
  /** $129 one-time, access until you pass (customer_creation=always). */
  fullAccess: 'https://buy.stripe.com/9B63cvdq6eWv6ecaPJ97G04',
  /** $79.99 every 3 months. */
  quarterly: 'https://buy.stripe.com/4gM7sLgCi9CbgSQga397G02',
  /** $124.99 / year. */
  annual: 'https://buy.stripe.com/3cI8wP4TA8y7fOM1f997G03',
} as const;
